import { render, staticRenderFns } from "./CarneDeletado.vue?vue&type=template&id=8ba388c0&scoped=true&"
import script from "./CarneDeletado.vue?vue&type=script&lang=js&"
export * from "./CarneDeletado.vue?vue&type=script&lang=js&"
import style0 from "./CarneDeletado.vue?vue&type=style&index=0&id=8ba388c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba388c0",
  null
  
)

export default component.exports